import {put,takeLatest,call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    GET_ORDER,
    GET_ORDER_SUCCESS,
    GET_ORDER_ERROR
}
    from "../../actions/order";
function* getOrderSaga(action) {
    try {
        const data=yield call(orderService.GetOrder,action.payload)
        yield put({
            type: GET_ORDER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_ORDER_ERROR,error: error.data
        });
    }
}

export function* getOrderSagaWatcher() {
    yield takeLatest(GET_ORDER,getOrderSaga);
}